export default __webpack_public_path__ + "static/media/logo_set.5de77ad8.png";